import { fetcher } from '@commenda/utils';

export default async function deleteWorkRequest(
  workRequestId: string,
  nextAuthToken: string
): Promise<boolean> {
  try {
    const res = await fetcher(
      `workRequest/${workRequestId}`,
      {
        method: 'DELETE',
      },
      nextAuthToken
    );

    if (!res.ok) return false;

    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}
